import $ from "jquery";
import PropTypes from "prop-types";
import React from "react";

/**
 * Render an icon that displays a help message when hovered.
 *
 * @example
 *   <HelpIcon content="These users can change the current status of other users" />
 */
class HelpIcon extends React.Component {
  /**
   * Enables the help popover when the component is mounted.
   */
  componentDidMount() {
    $(this.refs.icon).popover({
      container: "body",
      html: true,
      placement: "top",
      template:
        '<div class="help-icon popover" role="tooltip">' +
        '<div class="arrow"></div>' +
        '<div class="popover-content"></div>' +
        "</div>",
      trigger: "hover"
    });
  }

  /**
   * Renders the help icon as a circle with a question mark.
   *
   * @returns {object} The React element
   */
  render() {
    return <i className="fa fa-question-circle text-info" data-content={this.props.content} ref="icon" />;
  }
}

HelpIcon.propTypes = {
  content: PropTypes.string.isRequired
};

export default HelpIcon;
